import { EntriesTableDesktop } from './EntriesTableDesktop';
import { EntriesTableMobile } from './EntriesTableMobile';
import { EntriesTableProps } from './types';

export const EntriesTable = (props: EntriesTableProps) => {
  return (
    <>
      <div className="hidden md-msq:block">
        <EntriesTableDesktop {...props} />
      </div>
      <div className="block md-msq:hidden">
        <EntriesTableMobile {...props} />
      </div>
    </>
  );
};
